import { useSearchParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Heart } from 'lucide-react';

export default function Unsubscribed() {
  const [params] = useSearchParams();
  const ok = params.get('ok') === '1';

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#FDFBF7' }}>
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 py-24">
        <div
          className="max-w-lg w-full p-10 rounded-3xl text-center"
          style={{ backgroundColor: '#FFFFFF', boxShadow: '0 8px 30px rgba(0,0,0,0.06)' }}
          data-testid="unsubscribed-panel"
        >
          <div
            className="mx-auto w-16 h-16 rounded-2xl flex items-center justify-center mb-6"
            style={{ backgroundColor: ok ? '#78A18E20' : '#E57A4420' }}
          >
            <Heart className="w-8 h-8" style={{ color: ok ? '#78A18E' : '#E57A44' }} />
          </div>
          <h1
            className="text-3xl mb-3"
            style={{ fontFamily: 'Merriweather, serif', color: '#2C2A29' }}
            data-testid="unsubscribed-title"
          >
            {ok ? "You're unsubscribed" : "That link didn't work"}
          </h1>
          <p
            className="text-base leading-relaxed mb-8"
            style={{ fontFamily: 'Nunito, sans-serif', color: '#595553' }}
            data-testid="unsubscribed-message"
          >
            {ok
              ? "We've stopped the weekly Prayer Wall digest to your inbox. Peace be with you — you can rejoin any time from your profile."
              : "This unsubscribe link is invalid or has expired. If you'd like to stop receiving digest emails, please contact us and we'll take care of it."}
          </p>
          <Link
            to="/"
            className="inline-block px-8 py-3 rounded-full transition-all duration-300 hover:-translate-y-1"
            style={{
              fontFamily: 'Nunito, sans-serif',
              backgroundColor: '#E57A44',
              color: '#FDFBF7',
              fontWeight: 600
            }}
            data-testid="unsubscribed-home-btn"
          >
            Back to Love Restored
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
